import '../../sass/bidding-header.scss';
import '../../sass/writer-profile.scss';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import configureStore from '@core/reducers/configureStore';
import UserReducer from '@core/reducers/UserReducer';
import SiteReducer from '@core/reducers/SiteReducer';
import balanceReducer from '../account/reducers/balanceReducer';

import Header from '@bidding/shared/components/Header';
import initCookieBanner from '@common/helpers/initCookieBanner';

// Mini-bundle that mounts only `<Header />` on any page that needs it —
// server-rendered PHP entries (e.g. `/writer/{id}`) include this bundle
// so the header is a React island over the static HTML below. Single
// source of truth: the same `Header.jsx` component every bidding bundle
// (form / auth / account / bidding-flow) already uses.
//
// Reducers we wire in:
//   user    — `useHeaderData` dispatches `getUser()` on mount if the
//             auth state is unknown, so the `{authorized && …}` gate
//             can flip on and the dropdown renders
//   site    — nothing in Header reads it today, but the shared store
//             shape stays consistent with the other bundles (so future
//             subcomponents drop in without refactoring the store)
//   balance — `useHeaderData` shows the balance pill
const store = configureStore({
    user: UserReducer,
    site: SiteReducer,
    balance: balanceReducer,
});

const root = document.getElementById('bidding-header-root');
if (root) {
    // Optional per-brand overrides from the mount node:
    //   data-nav   — JSON [{label, href}, …] marketing nav (defaults to the
    //                standard How it works / Top writers / About us)
    //   data-links — JSON partial { newOrder, login, … } to override targets
    // Marketing brand pages set data-nav; the /writer page mounts bare and
    // keeps the defaults. Malformed JSON falls back to component defaults.
    // Config comes from the mount node's data-attrs (the brand layout emits
    // valid JSON). Parsed directly — a malformed value should fail loud, not
    // be swallowed into a silent default.
    const props = {};
    if (root.dataset.nav) props.nav = JSON.parse(root.dataset.nav);
    if (root.dataset.links) props.links = JSON.parse(root.dataset.links);
    // data-variant="hero" → transparent-over-hero home header; omitted = solid.
    if (root.dataset.variant) props.variant = root.dataset.variant;

    render(
        <Provider store={store}>
            <Header {...props} />
        </Provider>,
        root,
    );
}

// Cookie-consent banner close (markup + server gate in the shared PHP partial).
// Independent of the header root so it works even where the header isn't mounted.
initCookieBanner();
